/* WeQuote Dev Board — global search bar (Lee, 27 Aug). Lives in the top bar
 * on every screen; results open the card pop-up from anywhere. */
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useDevBoard } from '../DevBoardProvider'
import { searchCards } from '../core/search'
import { DL, statusLabels } from '../core/constants'
import { statusPillCls } from '../core/logic'
import { TitleWithBug } from './parts'

export const SearchBar: React.FC = () => {
  const { cards, openCardModal } = useDevBoard()
  const [q, setQ] = useState('')
  const [focused, setFocused] = useState(false)
  const [sel, setSel] = useState(0)
  const wrapRef = useRef<HTMLDivElement>(null)
  const hits = useMemo(() => searchCards(cards, q).slice(0, 30), [cards, q])
  const open = focused && q.trim().length > 0
  useEffect(() => { setSel(0) }, [q])
  useEffect(() => {
    const down = (e: MouseEvent) => { if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) setFocused(false) }
    document.addEventListener('mousedown', down)
    return () => document.removeEventListener('mousedown', down)
  }, [])
  const go = (id: number) => { openCardModal(id); setFocused(false); setQ('') }
  const SL = statusLabels()
  return (
    <div className="gs-wrap" ref={wrapRef}>
      <input
        className="gs-input"
        placeholder="Search cards…  (title, content, dev, customer, #id)"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onFocus={() => setFocused(true)}
        onKeyDown={(e) => {
          if (e.key === 'ArrowDown') { e.preventDefault(); setSel((s) => Math.min(s + 1, hits.length - 1)) }
          else if (e.key === 'ArrowUp') { e.preventDefault(); setSel((s) => Math.max(s - 1, 0)) }
          else if (e.key === 'Enter' && hits[sel]) go(hits[sel].feat.id)
          else if (e.key === 'Escape') { setFocused(false); (e.target as HTMLInputElement).blur() }
        }}
      />
      {open && (
        <div className="gs-pop">
          {hits.length === 0 && <div className="gs-none">No cards match “{q.trim()}”.</div>}
          {hits.map((h, i) => (
            <div key={h.feat.id} className={'gs-hit' + (i === sel ? ' sel' : '')}
              onMouseEnter={() => setSel(i)} onClick={() => go(h.feat.id)}>
              <span className="gs-id">#{h.feat.id}</span>
              <span className="gs-title"><TitleWithBug feat={h.feat} /></span>
              <span className={'status-pill ' + statusPillCls(h.feat)}>{SL[h.feat.status] || h.feat.status}</span>
              {h.feat.dev && <span className="gs-dev">{DL[h.feat.dev] || h.feat.dev}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
